//@ts-nocheck

import left_arrow from './left-arrow.png';
import Zoom_in from './Zoom_in.png';
import Zoom_out from './Zoom_out.png';
import Save from './Save.png';
import Undo from "./Undo.png";
import Redo from "./Redo.png";
import PositionTop from "./top.png"
import PositionBottom from "./bottom.png"
import PositionLeft from "./left.png"
import PositionRight from "./right.png"
import PositionCenter from "./center.png"
import Delete_icon from "./delete-icon.svg"
import Back_arrow from "./back-arrow.svg"
import Plus_icon from "./plus.png"
import Close_icon from "./close.svg"
import Up_icon from "./up.svg"
import Down_icon from "./down.svg"
import Left_icon from "./leftIcon.svg"
import Right_icon from "./rightIcon.svg"
import Logo_icon from "./logo.svg"
import Text_icon from "./text.svg"
import Preview_icon from "./preview.svg"
import Confirm_icon from "./confirm.svg"
import Rotate_icon from "./rotate.svg"


export const images = {
    "left_arrow.png": left_arrow,
    "Zoom_in.png": Zoom_in,
    "Zoom_out.png": Zoom_out,
    "Save.png": Save,
    "recycle_bin.png": Delete_icon,
    "Undo.png": Undo,
    "Redo.png": Redo,
    "position_top" : PositionTop,
    "position_bottom" : PositionBottom,
    "position_left" : PositionLeft,
    "position_right" : PositionRight,
    "position_center" : PositionCenter,
    "Back_arrow": Back_arrow,
    "Plus_icon": Plus_icon,
    "Close_icon": Close_icon,
    "Up_icon": Up_icon,
    "Down_icon": Down_icon,
    "Left_icon": Left_icon,
    "Right_icon": Right_icon,
    "Logo_icon": Logo_icon,
    "Text_icon": Text_icon,
    "Preview_icon": Preview_icon,
    "Confirm_icon": Confirm_icon,
    "Rotate_icon": Rotate_icon,
};
